import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'preview',
    loadChildren: () => import('./preview/preview.module').then(m => m.PreviewPageModule)
  },
  {
    path: 'resetpassword',
    loadChildren: () => import('./resetpassword/resetpassword.module').then(m => m.ResetpasswordPageModule)
  },
  {
    path: 'forgotpassword',
    loadChildren: () => import('./forgotpassword/forgotpassword.module').then(m => m.ForgotpasswordPageModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardPageModule)
  },
  {
    path: 'branch',
    loadChildren: () => import('./branch/branch.module').then(m => m.BranchPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'franchise',
    loadChildren: () => import('./franchise/franchise.module').then(m => m.FranchisePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'pricelist',
    loadChildren: () => import('./pricelist/pricelist.module').then(m => m.PricelistPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'shipment',
    loadChildren: () => import('./shipment/shipment.module').then(m => m.ShipmentPageModule)
  },
  {
    path: 'mission',
    loadChildren: () => import('./mission/mission.module').then(m => m.MissionPageModule)
  },
  {
    path: 'driver',
    loadChildren: () => import('./driver/driver.module').then(m => m.DriverPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'package',
    loadChildren: () => import('./package/package.module').then(m => m.PackagePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'report',
    loadChildren: () => import('./report/report.module').then(m => m.ReportPageModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then(m => m.ProfilePageModule)
  },
  {
    path: 'shoplist',
    loadChildren: () => import('./shoplist/shoplist.module').then(m => m.ShoplistPageModule)
  },
  {
    path: 'currencyconverter',
    loadChildren: () => import('./currencyconverter/currencyconverter.module').then(m => m.CurrencyconverterPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'barcode',
    loadChildren: () => import('./barcode/barcode.module').then(m => m.BarcodePageModule)
  },  {
    path: 'settlement',
    loadChildren: () => import('./settlement/settlement.module').then( m => m.SettlementPageModule)
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
